import { render, staticRenderFns } from "./ConsiderFormList.vue?vue&type=template&id=d920d2fa&scoped=true&"
import script from "./ConsiderFormList.vue?vue&type=script&lang=js&"
export * from "./ConsiderFormList.vue?vue&type=script&lang=js&"
import style0 from "./ConsiderFormList.vue?vue&type=style&index=0&id=d920d2fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d920d2fa",
  null
  
)

export default component.exports